import { getFullName } from '@pn/core/domain/user';
import { useCurrentUserStorage } from '@pn/core/storage';
import { isNil } from 'lodash-es';

const freshdeskGroupIds = {
  maps: 73000272857,
  intel: 73000489234,
};

/**
 * @note The group ID is in the URL of the freshdesk web app
 * @link https://developers.freshdesk.com/widget-api/#introduction
 */
export function useFreshdesk(groupId: keyof typeof freshdeskGroupIds) {
  const { user } = useCurrentUserStorage();

  const handleOpenContactUs = () => {
    window.FreshworksWidget('open');
    window.FreshworksWidget('hide', 'launcher');
    window.FreshworksWidget('hide', 'ticketForm', ['group_id']);
    window.FreshworksWidget('prefill', 'ticketForm', {
      group_id: freshdeskGroupIds[groupId],
    });
    if (!isNil(user)) {
      window.FreshworksWidget('identify', 'ticketForm', {
        name: getFullName(user),
        email: user.email,
      });
    }
  };

  return { handleOpenContactUs };
}
